// src/environment/environment.prod.js
const environment = {
    API_URL: 'https://bank.elexyt.com',
}

export default environment;
